import { t, Instance } from 'mobx-state-tree';
import type { LifeEventResponse } from 'we-tree-api-client/v2';

/**
 * LifeEventModel - Represents a life event (marriage, military service, etc.)
 */
export const LifeEventModel = t
  .model('LifeEventModel', {
    id: t.string,
    familyId: t.string,
    familyMemberId: t.string,
    participantIds: t.optional(t.array(t.string), []),
    eventTypeId: t.string,
    eventTypeSlug: t.string,
    eventTypeDisplayName: t.string,
    eventDate: t.maybeNull(t.string),
    eventDatePrecision: t.maybeNull(t.string),
    eventPlace: t.maybeNull(t.string),
    detail: t.maybeNull(t.string),
    description: t.maybeNull(t.string),
    sourceNotes: t.maybeNull(t.string),
    createdAt: t.string,
    updatedAt: t.string,
    createdByNickname: t.maybeNull(t.string),
    updatedByNickname: t.maybeNull(t.string)
  })
  .views(() => ({}));

export type LifeEventType = Instance<typeof LifeEventModel>;

/**
 * Create LifeEventModel from API response
 */
export function createLifeEventModelFromResponse(response: LifeEventResponse): Instance<typeof LifeEventModel> {
  return LifeEventModel.create({
    id: response.id,
    familyId: response.familyId,
    familyMemberId: response.familyMemberId,
    participantIds: response.participantIds ?? [],
    eventTypeId: response.eventTypeId,
    eventTypeSlug: response.eventTypeSlug,
    eventTypeDisplayName: response.eventTypeDisplayName,
    eventDate: response.eventDate ?? null,
    eventDatePrecision: response.eventDatePrecision ?? null,
    eventPlace: response.eventPlace ?? null,
    detail: response.detail ?? null,
    description: response.description ?? null,
    sourceNotes: response.sourceNotes ?? null,
    createdAt: response.createdAt ?? new Date().toISOString(),
    updatedAt: response.updatedAt ?? new Date().toISOString(),
    createdByNickname: (response as { createdByNickname?: string | null }).createdByNickname ?? null,
    updatedByNickname: (response as { updatedByNickname?: string | null }).updatedByNickname ?? null
  });
}
